import clsx from 'clsx';
import pikkocoin2 from '../../styles/img/1sur3.svg';
import './PikkoJackpotFloatingCoins.scss';

const COINS = [
  { pos: 'top-[5%] right-[22%]', size: 'w-14 h-14', delay: '600ms', rotate: 'rotate-12', anim: 'coinFloat1 3s ease-in-out 1.5s infinite' },
  { pos: 'bottom-[8%] left-[22%]', size: 'w-13 h-13', delay: '800ms', rotate: '-rotate-[15deg]', anim: 'coinFloat2 3.5s ease-in-out 2s infinite' },
  { pos: 'top-[30%] left-[15%]', size: 'w-12 h-12', delay: '1000ms', rotate: 'rotate-[20deg]', anim: 'coinFloat3 4s ease-in-out 2.3s infinite' },
  { pos: 'bottom-[20%] right-[18%]', size: 'w-11 h-11', delay: '1100ms', rotate: 'rotate-[8deg]', anim: 'coinFloat4 3.8s ease-in-out 2.5s infinite' },
  { pos: 'top-[15%] left-[28%]', size: 'w-10 h-10', delay: '1200ms', rotate: '-rotate-[25deg]', anim: 'coinFloat5 4.2s ease-in-out 2.8s infinite' },
];

export const PikkoJackpotFloatingCoins = ({ visible, isLastChance }) => (
  <>
    {COINS.map((coin) => (
      <img
        key={coin.pos}
        src={pikkocoin2}
        alt=""
        className={clsx(
          `${coin.size} object-contain absolute ${coin.pos} transition-all duration-700 ease-[cubic-bezier(0.34,1.6,0.64,1)]`,
          visible
            ? `opacity-100 scale-100 ${coin.rotate}`
            : 'opacity-0 scale-0 rotate-0',
        )}
        style={{
          transitionDelay: coin.delay,
          ...(visible ? { animation: coin.anim } : {}),
          filter: isLastChance ? 'grayscale(1) opacity(0.4)' : 'none',
        }}
      />
    ))}
  </>
);
